/** `/c/$companyId/entries/$entryId` — a posted entry, with Reverse. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { EntryScreen } from "../journals/EntryScreen";

export const Route = createFileRoute("/_auth/c/$companyId/entries/$entryId")({
  component: EntryRoute,
});

function EntryRoute(): JSX.Element {
  const { companyId, entryId } = Route.useParams();
  return <EntryScreen companyId={companyId} entryId={entryId} />;
}
